module.exports = __webpack_public_path__ + "img/video.8891ca18.webp";